import { createContext } from 'react';

export const ClothesContext = createContext();